import { Icon, Title } from "@justhome/react-ui";
import useLinks from "@lib/hooks/useLinks";
import MaximumBudgetCard from "@modules/application/components/MaximumBudgetCard";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { CheckOne } from "@icon-park/svg";

const BudgetCheckResult = () => {
  const {
    state: { maximumBudget },
  } = useApplicationContext();
  const { t } = useTranslation("budget-check");
  const router = useRouter();
  const { getApplicationProcessLink } = useLinks();
  const { partner } = usePartnerContext();

  useEffect(() => {
    if (!maximumBudget) {
      router.push(getApplicationProcessLink("budget-check"));
    }
  }, [maximumBudget, getApplicationProcessLink, router]);

  if (!maximumBudget) {
    return null;
  }

  const hasSearchProfile = !!maximumBudget.searchProfile?.placeId;

  const title =
    hasSearchProfile && partner ? (
      <div className="text-center mb-3s text-balance">
        <Icon icon={CheckOne} size="40" />
        <Title as="h1" className="text-h1">
          {t("result_title_search_profile", { partnerName: partner.name })}
        </Title>
      </div>
    ) : (
      <Title as="h1" className="text-center text-h1 mb-3s text-balance">
        {t("result_title")}
      </Title>
    );

  return (
    <div className="mx-auto w-[772px] max-w-full grow flex flex-col items-center mb-3s m:mb-3m">
      <div className="flex flex-col">
        {title}
        <MaximumBudgetCard maximumBudget={maximumBudget} />
        <p className="my-3s text-body-2">{t("result_note")}</p>
      </div>
    </div>
  );
};

export default BudgetCheckResult;
